const SalespersonEndpoints = {
    salesperson(reqData: any) {
      return {
        url: "sow/salePerson",
        data: reqData["reqBody"],
        headers: reqData["headers"],
      };
    }
  };
  export default SalespersonEndpoints;